import { render } from "./QuantityDiscount.vue?vue&type=template&id=d36877ba"
import script from "./QuantityDiscount.vue?vue&type=script&lang=js"
export * from "./QuantityDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__